module.exports = __webpack_public_path__ + "media/images/front/icons/info_edit-d9b01016b41007f00d2006f1db086150.png";